import React from "react";
import { SVG, IconProps } from "../SVG";

export const SpotMail = ({
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.4",
    size = 40,
    ...props
}: IconProps) => {
    return (
        <SVG
            size={size}
            viewBox="0 0 57 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_2834_56912)">
                <path
                    d="M48.7077 54.7061C39.2636 58.5917 31.6668 52.9601 22.869 47.9061C13.8948 42.0032 -0.556561 43.8429 0.614612 32.0049C1.54607 22.5898 12.3846 22.1667 20.9098 16.565C29.3856 10.9692 33.0569 8.26563 40.3632 10.6936C47.6202 13.1275 54.5865 17.8437 56.1729 26.4386C57.7099 35.0394 54.3805 51.1586 48.7077 54.7061Z"
                    fill={spotColor}
                />
                <path
                    d="M9.34761 10H47.7476C50.3876 10 52.5476 12.025 52.5476 14.5V41.5C52.5476 43.975 50.3876 46 47.7476 46H9.34761C6.70761 46 4.54761 43.975 4.54761 41.5V14.5C4.54761 12.025 6.70761 10 9.34761 10Z"
                    fill={spotColor}
                />
                <path d="M52.5476 14.5L28.5476 30.2494L4.54761 14.5" fill={spotColor} />
                <path
                    d="M52.5476 14.5C52.5476 12.025 50.3876 10 47.7476 10H9.34761C6.70761 10 4.54761 12.025 4.54761 14.5M52.5476 14.5V41.5C52.5476 43.975 50.3876 46 47.7476 46H9.34761C6.70761 46 4.54761 43.975 4.54761 41.5V14.5M52.5476 14.5L28.5476 30.2494L4.54761 14.5"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2834_56912">
                    <rect width="56" height="56" fill="white" transform="translate(0.547607)" />
                </clipPath>
            </defs>
        </SVG>
    );
};

SpotMail.displayName = "SpotMail";
